import React from "react";
import ConfirmUserPanel from "./ConfirmUserPanel";
import InvitationAlreadyAccepted from "./InvitationAlreadyAccepted";
import LandingPage from "./landingpage";
import { useLoaderData } from "react-router";
import { useIsLoggedIn } from "common/SessionContext";

const InvitationApp = () => {
  const isLoggedIn = useIsLoggedIn();
  const viewModel = useLoaderData<server.viewmodel.AdvancingParticipantLandingFrontModel>();
  const { invitation } = viewModel;
  const { value } = invitation.status;

  React.useEffect(() => {
    if (value === "acceptedByMe") {
      window.location.href = invitation.paths.provideAbsolute;
    }
  }, []);

  switch (value) {
    case "acceptedNotAuthenticated": return <InvitationAlreadyAccepted invitation={invitation} />;
    case "notAccepted":
      if (isLoggedIn) { return <ConfirmUserPanel invitation={invitation} />; } else { return <LandingPage invitation={invitation} />; }
  }

  return <div></div>;
};

export default InvitationApp;